var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"tile-solid",style:({height: _vm.props.size + 'px', width: _vm.props.size + 'px', background: _vm.props.color})})}
var staticRenderFns = []

export { render, staticRenderFns }